<template>
    <div id="log_in_wind" class="full_wind relative">
        <div class="ma">
            <!-- 发帖 -->
            <Fatie></Fatie>
        </div>
    </div>

</template>

<script >
    import Fatie from '../components/Fatie'
    import Chat from './Chat.vue'
    // import MultiChat from '../assets/MultiChat.js'
    import $ from 'jquery'

    export default {
        name:'homepage',
        components: {
            Fatie,
            Chat,
        },
        data () {
            return {
            }
        },
    }
</script>

<style lang="css" scoped>
.full_wind {
    margin-top: 40px;
    width: 100%;
    height: auto;
    /* background-color: #545C64; */
}
.ma {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* filter: blur(3px); */
}
.relative {
    position: relative;
}
</style>